"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var satcheljs_1 = require("satcheljs");
// Import mutators so they are initialized at the same time as the store
require("../mutators/conversationsLoadedMutator");
require("../mutators/oneRecipientSelectedMutator");
require("../mutators/subjectConversationSelectedMutator");
var storeData = {
    selectedConversationId: undefined,
    isLoading: false,
    isError: false,
    emailRecipientConversations: mobx_1.map({}),
};
exports.getStore = satcheljs_1.createStore('subjectPicker', storeData);
var store = exports.getStore();
exports.default = store;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/store/store.js
// module id = 1705
// module chunks = 2 3 4 45 108